import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu.component';
import { MenubarModule } from 'primeng/menubar';

@NgModule({
  declarations: [MenuComponent],
  imports: [MenubarModule, RouterModule],
  exports: [MenuComponent],
})
export class MenuComponentModule {}
